<template>
  <div class="container">
    <van-nav-bar title="优惠卷" left-arrow @click-left="onClickLeft" />
    <van-tabs v-model="active" animated @change="onActiveChange(active)">
      <van-tab v-for="index in couponStatusList" :key="index.active" :title="index.title">
        <div class="noOrders" v-if="couponList.length == 0">
          <div v-if="!firstLoading">你还没有优惠卷哦...</div>
          <van-loading v-else type="spinner" />
        </div>
        <div v-if="couponList.length > 0" style="height: 100%;overflow: auto;">
          <van-pull-refresh
            v-model="refreshing"
            @refresh="onRefresh"
            style="height: calc(100% - 24.2vw);overflow: auto;"
          >
            <van-list
              v-model="loading"
              :finished="finished"
              finished-text="到底啦~"
              @load="onLoad"
              :immediate-check="false"
            >
              <div
                v-for="(item, index) in couponList"
                :key="item.id"
                class="items"
                @click="useClick(item, index)"
              >
                <div class="box">
                  <div class="center">
                    <p class="title">{{ item.couponTitle }}</p>
                    <p class="timer">{{ item.beginTime }} - {{ item.endTime }}</p>
                    <div class="mes">
                      <div>详细信息</div>
                      <div @click="updateClick(item, index)">
                        <div style="width: 100%; height: 100%" v-if="item.update">
                          <img src="../../../assets/images/up.png" alt class="imageDec" />
                        </div>
                        <div style="width: 100%; height: 100%" v-else>
                          <img src="../../../assets/images/down.png" alt class="imageDec" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="right">
                    <div class="top"></div>
                    <div class="box_bottom"></div>
                    <p>
                      <span class="price">{{ item.couponTitle }}</span>
                    </p>
                    <p class="dec">{{ item.couponDescription }}</p>
                    <!-- <button @click="useClick(item, index)">立即使用</button> -->
                  </div>
                </div>
                <div class="boxBottom" v-if="item.update">
                  <p>限品类：{{ item.couponDescription }}</p>
                  <p>卷编码：{{ item.couponCode }}</p>
                </div>
              </div>
            </van-list>
            <div class="bottom" v-if="buttonStatus" @click="onConfirm()">
              <button class="bottomBtn">不使用优惠卷</button>
            </div>
          </van-pull-refresh>
        </div>
      </van-tab>
    </van-tabs>
  </div>
</template>
<script>
import {
  Col,
  Row,
  Tab,
  Tabs,
  Toast,
  List,
  PullRefresh,
  NavBar,
  Loading
} from "vant";
import service from "../../api/checkout/index";
import { parseTime } from "../../util/date.js";
import listener from "../../eventLlistener/listener.js";
import { router } from "../../router";
export default {
  components: {
    [Col.name]: Col,
    [Row.name]: Row,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Toast.name]: Toast,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh,
    [NavBar.name]: NavBar,
    [Loading.name]: Loading
  },
  data() {
    return {
      getParams: {},
      active: 0,
      couponStatusList: [
        { active: 1, title: "可用" },
        { active: 0, title: "不可用" }
      ],
      couponList: [],
      chosenCoupon: -1,
      userCouponStatusId: 1,
      showList: true,
      getValue: {},
      buttonStatus: false,
      page: 1,
      pageSize: 8,
      reachBottom: false,
      loading: false,
      finished: false,
      refreshing: false,
      firstLoading: true
    };
  },
  mounted() {
    this.page = 1;
    this.pageSize = 8;
    this.init();
  },
  methods: {
    onLoad() {
      this.page++;
      if (this.refreshing) {
        this.refreshing = false;
      }
      this.getList().then(couponList => {
        if (couponList.length !== 0) {
          //
          couponList.map(element => {
            element.addTime = parseTime(element.addTime);
            element.beginTime = parseTime(element.beginTime);
            element.endTime = parseTime(element.endTime);
          });
          this.couponList = couponList;
          this.loading = false;
        } else {
          couponList = [];
        }
        if (couponList.length < 8) {
          this.finished = true;
        }
      });
    },
    onRefresh() {
      this.page = 1;
      this.finished = false;
      this.loading = true;
      this.couponList = [];
      this.getList().then(couponList => {
        if (couponList.length !== 0) {
          couponList.map(element => {
            element.addTime = parseTime(element.addTime);
            element.beginTime = parseTime(element.beginTime);
            element.endTime = parseTime(element.endTime);
          });
          this.couponList = couponList;
          if (couponList.length < 8) {
            this.finished = true;
          }
          this.refreshing = true;
        } else {
          couponList = [];
          this.finished = true;
        }
        this.onLoad();
      });
    },
    init() {
      this.buttonStatus = true;
      this.firstLoading = true;
      this.loading = false;
      this.getList().then(couponList => {
        this.firstLoading = false;
        if (couponList.length !== 0) {
          this.loading = false;
          couponList.map(element => {
            element.addTime = parseTime(element.addTime);
            element.beginTime = parseTime(element.beginTime);
            element.endTime = parseTime(element.endTime);
          });
          this.couponList = couponList;
          if (couponList.length < 8) {
            this.finished = true;
            this.loading = false;
          }
        } else {
          couponList = [];
          this.buttonStatus = false;
        }
      });
    },
    getList() {
      return new Promise((resolve, reject) => {
        service
          .getCoupons(this.userCouponStatusId, this.page, this.pageSize)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject();
          });
      });
    },
    onClickLeft() {
        this.$router.go(-1);
    },
    clickChange(item, index) {
      // 点击每一个
      this.showList = false;
      this.chosenCoupon = index;

      if (item.isAvailable == false) {
        Toast("该卷不可用哦...");
        return;
      }
      let getParams = {};
      getParams.text = "选择优惠券";
      getParams.item = item;
      localStorage.setItem("backHis", JSON.stringify(getParams));
      this.$router.go(-1);
    },
    onActiveChange(active) {
      this.page = 1;
      this.firstLoading = true;
      this.loading = true;
      if (active == 0) {
        this.userCouponStatusId = 1;
        this.buttonStatus = true;
      } else {
        this.userCouponStatusId = 0;
        this.buttonStatus = false;
      }
      this.couponList = [];

      this.getList().then(couponList => {
        this.firstLoading = false;
        this.loading = false;
        if (couponList.length !== 0) {
          couponList.map(element => {
            element.addTime = parseTime(element.addTime);
            element.beginTime = parseTime(element.beginTime);
            element.endTime = parseTime(element.endTime);
          });
          this.couponList = couponList;
          if (couponList.length < 8) {
            this.finished = true;
            this.loading = false;
          }
        } else {
          couponList = [];
        }
      });
    },
    updateClick(item, index) {
      this.$set(
        this.couponList[index],
        "update",
        !this.couponList[index]["update"]
      );
    },
    useClick(item,index) {
       this.showList = false;
      this.chosenCoupon = index;
      let getParams = {};
      getParams.text = "选择优惠券";
      getParams.item = item;
      localStorage.setItem("backHis", JSON.stringify(getParams));
      this.$router.go(-1);
      if (item.isAvailable) {      
        this.$router.replace({
          name: "checkout",
          query: {
            goodsCode: this.$route.query.goodsCode,
            quantity: this.$route.query.quantity,
            skuCode: this.$route.query.skuCode,
            couponCode: item.couponCode,
            type: this.$route.query.type
          }
        });
      } else {
        Toast("优惠卷不可使用哦...");
        // this.getParams.userCouponStatusId = item.userCouponStatusId;
        this.$router.replace({
          name: "checkout",
          query: {
            goodsCode: this.$route.query.goodsCode,
            quantity: this.$route.query.quantity,
            skuCode: this.$route.query.skuCode,
            couponCode: item.couponCode,
            type: this.$route.query.type
          }
        });
      }
    },
    onConfirm() {
      let getParams = {};
      getParams.text = "不使用优惠券";
      localStorage.setItem("backHis", JSON.stringify(getParams));
      this.$router.go(-1);
    }
  }
};
</script>
<style lang="less" scoped>
@deep: ~">>>";
.container {
  width: 100%;
  height: 100%;
  background: #f7f7f7;
  .noOrders {
    width: 100%;
    text-align: center;
    font-size: 15px;
    color: #92909a;
    padding-top: 30vw;
  }
  .van-tabs {
    height: 100%;
  }
  @{deep}.van-tabs__content--animated {
    height: 100%;
  }
  @{deep}.van-tab__pane,
  @{deep}.van-tab__pane-wrapper {
    height: 100%;
  }
  .bottom {
    width: 100%;
    display: flex;
    justify-content: center;
    .bottomBtn {
      width: 80vw;
      height: 12vw;
      background: linear-gradient(-90deg, #ffbc81, #ff727e);
      border: 0;
      border-radius: 1.33vw;
      color: #fff;
      font-size: 4vw;
    }
  }
  .title {
    font-weight: bold;
  }
  .timer {
    color: #666;
    font-size: 3.4vw;
  }
  .mes {
    color: #aaa;
    font-size: 3.4vw;
    display: flex;
    padding-bottom: 3.2vw;
    padding-right: 4.6vw;
    justify-content: space-between;
  }
  .dec {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
  }
  .imageDec {
    width: 4.26667vw;
    height: 4.26667vw;
  }
  .right {
    .top {
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background: #f7f7f7;
      position: absolute;
      top: -5px;
      left: -5px;
    }
    .box_bottom {
      border-radius: 50%;
      background: #f7f7f7;
      bottom: -1vw;
      left: -1.33333vw;
      width: 2.66667vw;
      height: 2.66667vw;
      position: absolute;
    }
  }

  .boxBottom {
    p {
      margin: 0;
      padding-top: 2vw;
      font-size: 3.2vw;
      color: #ccc;
    }
    height: 13.86667vw;
    padding: 1vw 2vw;
    background: #fcfcfc;
    box-shadow: 0px 4px 6px 0px rgba(16, 94, 174, 0.1);
  }
  .items {
    padding: 3.2vw;
    .box {
      background: linear-gradient(-45deg, #ffbc81, #ff727e);
      display: flex;
      .center {
        width: 64vw;
        font-size: 3.8vw;
        background: #fff;
        padding-left: 10px;
        box-shadow: 0px 4px 6px 0px rgba(16, 94, 174, 0.1);
      }
      .right {
        p {
          margin: 0;
        }
        position: relative;
        width: 26.67vw;
        padding: 3vw 1vw;
        text-align: center;
        color: #fff;
        font-size: 14px;
        margin: 0 auto;
        .price {
          font-size: 30px;
        }
        button {
          color: #ff727e;
          border: 0;
          border-radius: 20px;
          padding: 5px 10px;
          background: #fff;
        }
      }
    }
  }
  .van-loading {
    background: #f8f8f8;
  }
}
</style>